export default __webpack_public_path__ + "7a12c5ee84f73ca28f6a3eebdc84198c.png";